import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { WhatsappTemplateService } from '../../whatsapp-template/whatsapp-template.service';
import { salonStepsAppMainUrl, swarnAppMainUrl } from '../../../shared/utils/comon-utils';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-messagify-user-popup',
  templateUrl: './messagify-user-popup.component.html',
  styleUrls: ['./messagify-user-popup.component.scss']
})
export class MessagifyUserPopupComponent {
    isSwarnAppBranch = environment.baseUrl === swarnAppMainUrl;
    isSalonStepsBranch = environment.baseUrl === salonStepsAppMainUrl;
  
  constructor(public activeModal: NgbActiveModal, public whatsappTemplateService: WhatsappTemplateService,
  ) {}
  userForm = {
    username: '',
    password: '',
    email: '',
    gstNo: '',
    getTrn: '',
    ipAddress: '',
    accessToken:'',
    phoneNumber:'',
    phoneNumberId:'',
    wabaId:'',
    businessId:''
  };

  save() {
    this.userForm.phoneNumberId = this.userForm.phoneNumber;
    this.whatsappTemplateService.insertMsgiFlyUserDetails(this.userForm)
      .subscribe({
        next: (res) => {
          this.activeModal.close(res);
        },
        error: (err) => {
          console.error('Error saving:', err);
        }
      });
  }
  close() {
}
}
